import React from "react";
import { AddressListBody } from "tsi-common-react/src/apps/customer-account/AddressListBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressListDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AddressListBody {...props} />
    </PageSkeleton>
);
